import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../auth/SimpleAuthProvider";
import { useLadderStage } from "../data/ladder.selectors";
import LadderOfWealthChart from "./LadderOfWealthChart";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WealthLadderModule = ({ quizResult: parentQuizResult, onRetakeQuiz }) => {
  const { user } = useAuth();
  const { stage, hasData, loading } = useLadderStage(user?.id);
  const [diagnosisData, setDiagnosisData] = useState(null);
  const [diagnosisLoading, setDiagnosisLoading] = useState(true);
  
  // Check if user is premium
  const isPremium = user?.subscription_plan === 'premium';

  // Fetch diagnosis completion status
  useEffect(() => {
    const fetchDiagnosisStatus = async () => {
      try {
        const response = await axios.get(`${API}/diagnosis/latest`);
        setDiagnosisData(response.data);
      } catch (error) {
        console.error("Error fetching diagnosis:", error);
        setDiagnosisData(null);
      } finally {
        setDiagnosisLoading(false);
      }
    };

    if (user?.id) {
      fetchDiagnosisStatus();
    }
  }, [user?.id]);

  if (loading || diagnosisLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
        <p>Calculating your wealth stage...</p>
      </div>
    );
  }

  const diagnosisCompleted = diagnosisData !== null;
  const userStage = diagnosisData?.results?.ladder_stage || stage;
  const quizStageLevel = parentQuizResult?.stage_level || null;
  const quizDirection = parentQuizResult?.direction || null;

  return (
    <div className="space-y-6">
      <LadderOfWealthChart 
        stage={stage} 
        hasData={hasData} 
        diagnosisCompleted={diagnosisCompleted}
        userStage={userStage}
        quizStageLevel={quizStageLevel}
        quizDirection={quizDirection}
        onRetakeQuiz={onRetakeQuiz}
        isPremium={isPremium}
      />
    </div>
  );
};

export default WealthLadderModule;
